// File: src/components/questionnaires/IntroScreen.js
// -----------------------------------------------------------------------------
// Écran d'introduction générique pour les questionnaires
// -----------------------------------------------------------------------------
import React from 'react';

export default function IntroScreen({ prenom, onStart, config }) {
  const { icon, title, description, reassurances, duration } = config;

  return (
    <div className="relative flex-1 flex flex-col items-center justify-center p-6 overflow-hidden">
      {/* Blobs decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute w-72 h-72 rounded-full blur-[80px] opacity-30 bg-indigo-500 -top-24 -right-24 animate-blob1" />
        <div className="absolute w-64 h-64 rounded-full blur-[80px] opacity-30 bg-violet-500 -bottom-12 -left-20 animate-blob2" />
        <div className="absolute w-52 h-52 rounded-full blur-[80px] opacity-25 bg-pink-500 bottom-1/5 -right-16 animate-blob3" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center max-w-md text-center">
        {/* Icon */}
        <div className="w-24 h-24 mb-8 text-indigo-400">
          {icon}
        </div>

        <h1 className="text-2xl md:text-3xl font-medium text-white mb-4 whitespace-pre-line">
          {typeof title === 'function' ? title(prenom) : title}
        </h1>

        {/* Time indicator */}
        <div className="flex items-center gap-2 text-zinc-500 mb-8">
          <span>{duration}</span>
        </div>

        <p className="text-zinc-400 mb-8 whitespace-pre-line">
          {description}
        </p>

        {/* Reassurance items */}
        {/* <div className="flex flex-col gap-3 mb-8 w-full">
          {reassurances.map((text, index) => (
            <div key={index} className="flex items-center gap-3 text-zinc-300">
              <span className="flex items-center justify-center w-6 h-6 rounded-full bg-indigo-500/20 text-indigo-400 text-sm">✓</span>
              <span>{text}</span>
            </div>
          ))}
        </div> */}


        {/* Start button */}
        <button
          onClick={onStart}
          className="flex items-center gap-2 px-8 py-4 bg-indigo-600 hover:bg-indigo-500 text-white font-semibold rounded-xl transition-all transform hover:scale-105 shadow-lg shadow-indigo-500/25"
        >
          <span>C'est parti</span>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </button>
      </div>
    </div>
  );
}
